<template>
  <div v-if="activePanelNotInitialPanel">
    <div v-if="loading">
      <dd-loading-indicator style="height: 80vh"></dd-loading-indicator>
    </div>
    <div v-else-if="dynamicComponent">
      <component :is="dynamicComponent"></component>
    </div>
  </div>
</template>

<script>
import dashboardApi from "../../../api/dashboard";
export default {
  name: "DashboardIndex",
  props: {
    initialPanel: {
      type: String,
      required: false
    },
    activeViewName: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      view: this.panel,
      loading: false,
      dynamicComponent: null,
    }
  },
  mounted() {
    if(this.activePanelNotInitialPanel) {
      this.loadActiveView();
    }
    else {
      this.displayInitialPanel();
    }
  },
  computed: {
    activePanelNotInitialPanel() {
      return this.initialPanel !== this.activeViewName;
    }
  },
  activated() {
    if (!this.activePanelNotInitialPanel) {
      this.displayInitialPanel();
    }
  },
  deactivated() {
    if (this.activePanelNotInitialPanel) {
      this.hideInitialPanel();
    }
  },
   methods: {
      hideInitialPanel() {
        document.getElementById('initial-panel').style.display = 'none';
        document.getElementById('active-panel').style.display = 'flex';
      },
     displayInitialPanel() {
       document.getElementById('initial-panel').style.display = 'initial';
       document.getElementById('active-panel').style.display = 'none';
     },
     loadActiveView() {
       this.loading = true;
       this.hideInitialPanel()
       dashboardApi.view(this.activeViewName)
           .then(response => {
             this.view = response;
             this.dynamicComponent = {
               template: `<div>${response}</div>`,
             };
             this.loading = false;
           })
           .catch(error => {
             console.error(error);
           });
     }
   }
};
</script>

<style scoped>

</style>
